// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface RacialEthnicGroupDTO extends EntitySelectorDTO { 
	id: number;
	name: string | null;
	abbreviation: string | null;
}

const RacialEthnicGroupDTO = {
    className: 'RacialEthnicGroupDTO',
    create: (initValues?: Partial<RacialEthnicGroupDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			name: "",
			abbreviation: "",
        },
        initValues);
    },
	id: 'id',
	name: 'name',
	abbreviation: 'abbreviation',
};

export default RacialEthnicGroupDTO;